import 'plyr/dist/plyr.css';
import PropTypes from 'prop-types';
import React from 'react';

import { tokens } from '@companycam/slab';

import PromoModalVideoPlayer from 'components/shared/PromoModalVideoPlayer';
import CCModal from 'components/shared/DesignSystem/CCModal/CCModal';

const YOUTUBE_URL = 'https://youtu.be/qGJE-60McKk';

const PagesVideoModal = ({ onRequestClose }) => {
  return (
    <CCModal
      isOpen
      showCloseButton={false}
      shouldCloseOnOverlayClick
      size="medium"
      bodyStyle={{ padding: tokens.size_spacing_xl }}
      onRequestClose={onRequestClose}
    >
      <PromoModalVideoPlayer
        youtubeSrc={YOUTUBE_URL}
        autoplay
        style={{ borderRadius: tokens.size_border_radius_xl }}
      />
    </CCModal>
  );
};

PagesVideoModal.propTypes = {
  onRequestClose: PropTypes.func,
};

export default PagesVideoModal;
